module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu-item-group', {
    attrs: {
      "title": _vm.Language(this.menuGroupName)
    }
  }, [_vm._l((this.menuData), function(item) {
    return [(item.children) ? [_c('el-submenu', {
      key: item.type + item.id,
      attrs: {
        "label": _vm.Language(item.name),
        "value": item.id,
        "index": item.id,
        "title": _vm.Language(item.name)
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      staticClass: "iconfont",
      class: _vm.getIcon(item.picCode)
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.Language(item.name))), (item.qty && (item.qty > 0)) ? _c('b', {
      staticClass: "menu_num"
    }, [_vm._v(_vm._s(item.qty > 99 ? '99+' : item.qty))]) : _vm._e()])]), _vm._v(" "), _c('menu-tree', {
      attrs: {
        "menuData": item.children,
        "menuGroupName": item.name
      },
      on: {
        "menuClick": _vm.navListClick
      }
    })], 2)] : [_c('el-menu-item', {
      key: item.type + item.id,
      attrs: {
        "label": _vm.Language(item.name),
        "value": item.id,
        "index": item.name,
        "title": _vm.Language(item.name)
      },
      on: {
        "click": function($event) {
          return _vm.navListClick(item)
        }
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      staticClass: "iconfont",
      class: _vm.getIcon(item.picCode)
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.Language(item.name))), (item.qty && (item.qty > 0)) ? _c('b', {
      staticClass: "menu_num"
    }, [_vm._v(_vm._s(item.qty > 99 ? '99+' : item.qty))]) : _vm._e()])])], 2)]]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-192e2ac8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/LeftNav/menuTree.vue
// module id = 1321
// module chunks = 5